const configReview = {
    list: {
        listLayout: 'ReviewListDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getReview',
        listApiParamSet: {type: 'post', ip: 1, r: 1, wr:1},

        deleteFunc: 'deleteReview',
        deleteApiParamsSet: {type: 'post', wr_type: 'post', rate: 'delete'},
        deleteSuccessType: 1,
        deleteErrorTypes: {},
        keyName: 'wr_id',
    },
}
export default {
    methods : {
        returnReviewConfig(type) {
            return configReview[type];
        }
    },
    filterConfig: {},
}
